function initMap() {

	console.log('init map');
	var mapLocations = data_locations;
	var mapElement = document.getElementById('googlemap');
	var mapOptions = {

		center: new google.maps.LatLng(data_center[0],data_center[1]),
		zoom: data_zoom,
		draggable: true,
		scrollwheel: false,
		scaleControl: true,
		panControl: false,
		zoomControl: true,
		mapTypeControl: false,
		streetViewControl: false,
		fullscreenControl: false,

		styles: [
			{
				"featureType": "all",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"saturation": 36
					},
					{
						"color": "#000000"
					},
					{
						"lightness": "-100"
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#ffffff"
					},
					{
						"lightness": "100"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#000000"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 17
					},
					{
						"weight": 1.2
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"visibility": "on"
					},
					{
						"lightness": "-5"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": "90"
					}
				]
			},
			{
				"featureType": "poi.park",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"lightness": "86"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"visibility": "on"
					},
					{
						"lightness": "-100"
					},
					{
						"weight": "1.00"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": "-100"
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": "-100"
					},
					{
						"weight": "0.65"
					},
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": "-100"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": "-100"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": "-100"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#fffcfc"
					},
					{
						"invert_lightness": true
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 19
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#747474"
					}
				]
			},
			{
				"featureType": "transit.station",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#919191"
					}
				]
			},
			{
				"featureType": "transit.station.airport",
				"elementType": "geometry",
				"stylers": [
					{
						"lightness": "80"
					},
					{
						"gamma": "1"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": "20"
					},
					{
						"gamma": "1"
					}
				]
			}
		]

		/*[
			{
				"featureType": "all",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"saturation": 36
					},
					{
						"color": "#ffffff"
					},
					{
						"lightness": 40
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#000000"
					},
					{
						"lightness": 16
					}
				]
			},
			{
				"featureType": "all",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": "10"
					},
					{
						"gamma": "1"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": "10"
					},
					{
						"weight": "1"
					},
					{
						"gamma": "1"
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": "0"
					},
					{
						"gamma": "1"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#313131"
					},
					{
						"lightness": "10"
					},
					{
						"gamma": "1"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#f9f9f9"
					},
					{
						"visibility": "on"
					},
					{
						"weight": "0.5"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": 17
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 29
					},
					{
						"weight": 0.2
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": 18
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 16
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#fffcfc"
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 19
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#414141"
					}
				]
			},
			{
				"featureType": "transit.station",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#919191"
					}
				]
			},
			{
				"featureType": "transit.station.airport",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#9e9e9e"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#efefef"
					},
					{
						"lightness": "-50"
					},
					{
						"visibility": "on"
					}
				]
			}
		]*/

	};

	var mapObject = new google.maps.Map(mapElement, mapOptions);
	var windowObject = new google.maps.InfoWindow();
	var markerObject, i;
	var pointer = {
		url: '/theme/public/assets/images/logo/le-rad-small.svg',
		anchor: new google.maps.Point(20,40),
		scaledSize: new google.maps.Size(40,40)
	}

	for (i = 0; i < mapLocations.length; i++) {

		markerObject = new google.maps.Marker({
			position: new google.maps.LatLng(mapLocations[i][0], mapLocations[i][1]),
			icon: pointer,
			map: mapObject,
		});

		google.maps.event.addListener(markerObject, 'mouseover', (function (markerObject, i) {
			return function () {
				windowObject.setContent('<div class="maps infobox">' + mapLocations[i][2] + '</div>');
				windowObject.open(mapObject, this);
			}
		})(markerObject, i));

	}

}


